import { Typography } from '@mui/material';
import { styled, TypographyProps } from '@mui/material';

export const Root = styled((props: TypographyProps) => <Typography variant="textSmRegular" {...props} />)(
  ({ theme }) => ({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    aspectRatio: 1,
    color: theme.palette.common.white,
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.common.white}`,
  })
);
